import { render } from "./ice-breakers.vue?vue&type=template&id=60c9c6b2"
import script from "./ice-breakers.vue?vue&type=script&lang=js"
export * from "./ice-breakers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__